import {
  ProcedureFactory,
  ProcedureFactoryError,
  ProcedureJsonData,
  Procedure,
  ProcedureId,
  ProcedureStatus,
  ProcedureType,
  ProcedureDateLimit
} from '@/Domain/Procedures'
import { DogaInfo, DogaUrl, DogaDate, DogaNumber } from '@/Domain/Procedures/Doga'
import {
  CelebrationInfo,
  CelebrationDate,
  CelebrationPlace,
  CelebrationTime
} from '@/Domain/Procedures/Celebration'

export class StandardProcedureFactory implements ProcedureFactory<ProcedureJsonData> {
  makeProcedure (data: ProcedureJsonData): Procedure {
    try {
      const celebrationTime = data.celebrationTime === '-' ? '-' : data.celebrationTime
      return new Procedure(
        new ProcedureId(data.procedureId),
        data.procedureType as ProcedureType,
        data.procedureStatus as ProcedureStatus,
        data.provinceCode,
        new DogaInfo(
          new DogaDate(data.publishDate),
          new DogaNumber(data.dogaNumber > 0 ? data.dogaNumber : 1),
          new DogaUrl(data.dogaUrl)
        ),
        new CelebrationInfo(
          new CelebrationPlace(data.celebrationPlace),
          new CelebrationDate(data.celebrationDate),
          new CelebrationTime(celebrationTime)
        ),
        new ProcedureDateLimit(data.limitDate)
      )
    } catch (error) {
      throw new ProcedureFactoryError(error.msg)
    }
  }
}
